import React, { useState } from "react";
import { Card, Table, Tag, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import { FetchStockTransferHistory_api } from "../../Api/Stock/stock_api";

export const StockTransferHistory = () => {
  // Pagination & Search
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");

  const { data: historyData, isFetching } = useQuery({
    queryKey: ["stock_transfer_history", page, pageSize, searchText],
    queryFn: () => FetchStockTransferHistory_api(page, pageSize, searchText),
  });

  const columns = [
    {
      title: "Date / Time",
      dataIndex: "transfer_date",
      key: "transfer_date",
      width: 180,
      render: (text: string) => <span className="text-gray-600">{text}</span>,
    },
    {
      title: "Vehicle",
      key: "vehicle",
      render: (record: any) => (
        <div>
          <div className="font-bold">
            {record.v_type} - {record.v_modal}
          </div>
          <div className="text-xs text-gray-500">
            Eng: {record.engine_number}
          </div>
        </div>
      ),
    },
    {
      title: "From",
      key: "from_dealer_name",
      render: (record: any) => (
        <span className="font-medium text-blue-700">
          {record.from_dealer_name}
        </span>
      ),
    },
    {
      title: "To Dealer",
      key: "to_dealer_name",
      render: (record: any) => (
        <span className="font-medium text-blue-700">
          {record.to_dealer_name}
        </span>
      ),
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      key: "remarks",
      render: (text: string) => (
        <span className="text-gray-500 italic">{text || "-"}</span>
      ),
    },
  ];

  return (
    <div className="w-full min-h-screen bg-gray-50 p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-900">
          Stock Transfer History
        </h1>
        <Input
          placeholder="Search history..."
          prefix={<SearchOutlined />}
          className="w-64"
          onChange={(e) => {
            setSearchText(e.target.value);
            setPage(1);
          }}
        />
      </div>

      <Card className="shadow-sm rounded-xl border-none">
        <Table
          className="overflow-x-auto"
          loading={isFetching}
          dataSource={historyData?.data || []}
          columns={columns}
          rowKey="id"
          pagination={{
            current: page,
            pageSize: pageSize,
            total: historyData?.total || 0,
            onChange: (p, ps) => {
              setPage(p);
              setPageSize(ps);
            },
            showSizeChanger: true,
          }}
        />
      </Card>
    </div>
  );
};
